package com.evoapps.evoshift.kiosk

/** SH-111: what one scan of the tablet's code gave. */
sealed interface QrScan {
    /** A QR code's text (not checked yet: the view model and the server do that). */
    data class Code(val text: String) : QrScan

    /** The person closed the scanner. */
    data object Cancelled : QrScan

    /** The camera permission was refused. */
    data object PermissionDenied : QrScan

    /** No camera or no scanner on this device after all. */
    data object Unavailable : QrScan
}

/**
 * The camera scanner for the tablet's rotating QR (SH-111): Google's code scanner on Android (no
 * camera permission in the app), AVFoundation on iOS, the browser's BarcodeDetector on the web.
 * The camera image never leaves the device; only the decoded text is used.
 */
interface QrScanner {
    /** Whether this device can scan at all: the "Scan the tablet's code" entry is hidden otherwise. */
    val isAvailable: Boolean

    /** Opens the scanner and returns the first QR code it sees, or why there is none. */
    suspend fun scan(): QrScan
}

/** Platforms without a scanner (the desktop app). */
object NoQrScanner : QrScanner {
    override val isAvailable = false
    override suspend fun scan(): QrScan = QrScan.Unavailable
}

expect fun platformQrScanner(): QrScanner
